import React, { useState } from 'react';
import Logo from './Logo';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white/90 backdrop-blur border-b border-neutral-200/70 sticky top-0 z-50">
      <div className="container-max">
        <div className="flex justify-between items-center py-4">
          <div className="flex items-center">
            <Logo />
          </div>

          <nav className="hidden md:flex space-x-10 absolute left-1/2 transform -translate-x-1/2">
            {[
              { href: '#services', label: 'Services' },
              { href: '#testimonials', label: 'Reviews' },
              { href: '#product', label: 'Product' },
              { href: '#contact', label: 'Contact' },
            ].map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="text-sm text-neutral-600 hover:text-black transition-colors"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:block">
            <a
              href="https://calendar.app.google/cnN9KoLp6WZYMX9G7"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center bg-black hover:bg-neutral-800 text-white text-sm font-medium px-5 py-2.5 rounded-full transition-colors"
            >
              Book consultation
            </a>
          </div>

          <button
            className="md:hidden p-2 text-neutral-700"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>

        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-neutral-200">
            <nav className="flex flex-col space-y-4">
              <a href="#services" className="text-neutral-700 hover:text-black transition-colors">Services</a>
              <a href="#testimonials" className="text-neutral-700 hover:text-black transition-colors">Reviews</a>
              <a href="#product" className="text-neutral-700 hover:text-black transition-colors">Product</a>
              <a href="#contact" className="text-neutral-700 hover:text-black transition-colors">Contact</a>
              <a
                href="https://calendar.app.google/cnN9KoLp6WZYMX9G7"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center bg-black hover:bg-neutral-800 text-white font-medium px-5 py-3 rounded-full transition-colors w-full"
              >
                Book consultation
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
